<div id="wrapper">
    <app-navbar></app-navbar>

    <app-sidebar [isCondensed]="isCondensed"></app-sidebar>

    <div class="content-page">
        <div class="content">
            <div class="content-pane">
                <div class="container-fluid">
                    <div class="breadcrumb">
                        <span class="breadcrumb-item">
                            <a href="javascript:void(0)">PayEXAP</a>
                        </span>
                        <span class="px-2"
                            ><i class="ri-arrow-right-s-line"></i
                        ></span>
                        <span class="breadcrumb-item" aria-current="page">
                            <a routerLink="/purchase-orders">Purchase Orders</a>
                        </span>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div
                                *ngIf="sessionExpired"
                                class="alert alert-danger session-text text-center"
                                role="alert"
                            >
                                {{ errorMsg }}
                                <span class="relogin" (click)="accountLogout()"
                                    >Click here to LogIn</span
                                >
                            </div>
                            <div class="card">
                                <div class="card-body">
                                    <div class="pane-header mb-3">
                                        <h4 class="mt-2">
                                            View PO/GRN and Submit Invoices
                                        </h4>
                                    </div>
                                    <div class="search-pane">
                                        <div class="row">
                                            <div class="col-md-2">
                                                <label
                                                    class="d-inline-flex align-items-center mb-3"
                                                >
                                                    <select
                                                        class="form-select form-select-sm mx-1"
                                                        (change)="
                                                            onFilter($event)
                                                        "
                                                    >
                                                        <option
                                                            disabled
                                                            selected
                                                            hidden
                                                        >
                                                            Select
                                                        </option>
                                                        <option
                                                            value="po_number"
                                                        >
                                                            PO No.
                                                        </option>
                                                        <option
                                                            value="po_currency"
                                                        >
                                                            PO Currency
                                                        </option>
                                                        <option
                                                            value="location"
                                                        >
                                                            Location
                                                        </option>
                                                    </select>
                                                </label>
                                            </div>
                                            <div class="col-md-4">
                                                <div
                                                    class="input-group flex-nowrap"
                                                >
                                                    <ng-container
                                                        *ngIf="selectedOption"
                                                    >
                                                        <input
                                                            type="text"
                                                            class="form-control highlighted"
                                                            placeholder="Enter search value here"
                                                            aria-label="search"
                                                            aria-describedby="addon-wrapping"
                                                            (keyup)="
                                                                onSearch($event)
                                                            "
                                                        />
                                                        <span
                                                            class="input-group-text highlighted"
                                                            id="addon-wrapping"
                                                            ><i
                                                                class="ri-search-line"
                                                            ></i
                                                        ></span>
                                                    </ng-container>
                                                    <ng-container
                                                        *ngIf="!selectedOption"
                                                    >
                                                        <input
                                                            type="text"
                                                            class="form-control"
                                                            placeholder="Search..."
                                                            aria-label="search"
                                                            aria-describedby="addon-wrapping"
                                                            (keyup)="
                                                                generalSearch(
                                                                    $event
                                                                )
                                                            "
                                                        />
                                                        <span
                                                            class="input-group-text"
                                                            id="addon-wrapping"
                                                            ><i
                                                                class="ri-search-line"
                                                            ></i
                                                        ></span>
                                                    </ng-container>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div
                                                    class="download-pane float-end"
                                                >
                                                    <i
                                                        class="ri-refresh-line me-2"
                                                        (click)="refreshData()"
                                                        title="Refresh"
                                                    ></i>
                                                    <i
                                                        class="ri-file-download-line"
                                                        (click)="
                                                            exportToExcel()
                                                        "
                                                    ></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="table-responsive">
                                        <ng-container *ngIf="loading">
                                            <div class="text-center">
                                                <app-loader></app-loader>
                                            </div>
                                        </ng-container>

                                        <ng-container *ngIf="!loading">
                                            <div
                                                *ngIf="isEmpty"
                                                class="text-center py-5"
                                            >
                                                <img
                                                    src="assets/images/empty-state.png"
                                                    alt="No-data"
                                                />
                                                <h1 class="card-title my-2">
                                                    No Purchases Orders
                                                    Available
                                                </h1>
                                                <p class="card-text">
                                                    There is no available data
                                                    to show yet
                                                </p>
                                            </div>
                                            <ng-container *ngIf="!isEmpty">
                                                <table
                                                    aria-describedby="purchase-orders"
                                                    id="demo-foo-pagination"
                                                    class="table mb-0 table-striped toggle-arrow-tiny tablet breakpoint purchase-orders text-nowrap"
                                                    data-page-size="5"
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th
                                                                scope="col"
                                                                [appSort]="pos"
                                                                data-order="desc"
                                                                data-name="po_no"
                                                                class="text-center"
                                                            >
                                                                PO No
                                                                <span
                                                                    class="sort-indicator"
                                                                    ><i
                                                                        class="bi bi-chevron-expand"
                                                                    ></i
                                                                ></span>
                                                            </th>

                                                            <th
                                                                scope="col"
                                                                [appSort]="pos"
                                                                data-order="desc"
                                                                data-name="po_ses_mat"
                                                                class="text-center"
                                                            >
                                                                PO Type
                                                                <span
                                                                    class="sort-indicator"
                                                                    ><i
                                                                        class="bi bi-chevron-expand"
                                                                    ></i
                                                                ></span>
                                                            </th>

                                                            <th
                                                                scope="col"
                                                                [appSort]="pos"
                                                                data-order="desc"
                                                                data-name="location"
                                                                class="text-center"
                                                            >
                                                                Location
                                                                <span
                                                                    class="sort-indicator"
                                                                    ><i
                                                                        class="bi bi-chevron-expand"
                                                                    ></i
                                                                ></span>
                                                            </th>

                                                            <th
                                                                scope="col"
                                                                [appSort]="pos"
                                                                data-order="desc"
                                                                data-name="po_value"
                                                            >
                                                                PO Amount
                                                                <span
                                                                    class="sort-indicator"
                                                                    ><i
                                                                        class="bi bi-chevron-expand"
                                                                    ></i
                                                                ></span>
                                                            </th>

                                                            <th
                                                                scope="col"
                                                                [appSort]="pos"
                                                                data-order="desc"
                                                                data-name="openPoValue"
                                                            >
                                                                Open PO Amount
                                                                <span
                                                                    class="sort-indicator"
                                                                    ><i
                                                                        class="bi bi-chevron-expand"
                                                                    ></i
                                                                ></span>
                                                            </th>

                                                            <th
                                                                scope="col"
                                                                [appSort]="pos"
                                                                data-order="desc"
                                                                data-name="invoicedAmount"
                                                            >
                                                                Invoiced Amount
                                                                <span
                                                                    class="sort-indicator"
                                                                    ><i
                                                                        class="bi bi-chevron-expand"
                                                                    ></i
                                                                ></span>
                                                            </th>

                                                            <th
                                                                scope="col"
                                                                [appSort]="pos"
                                                                data-order="desc"
                                                                data-name="inProcessInvoicedAmount"
                                                            >
                                                                In-Process
                                                                Invoice Amount
                                                                <span
                                                                    ><i
                                                                        class="bi bi-chevron-expand"
                                                                    ></i
                                                                ></span>
                                                            </th>

                                                            <th
                                                                scope="col"
                                                                [appSort]="pos"
                                                                data-order="desc"
                                                                data-name="po_currency"
                                                                class="text-center"
                                                            >
                                                                PO Currency
                                                                <span
                                                                    class="sort-indicator"
                                                                    ><i
                                                                        class="bi bi-chevron-expand"
                                                                    ></i
                                                                ></span>
                                                            </th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        <tr
                                                            *ngFor="
                                                                let po of pos
                                                            "
                                                        >
                                                            <td
                                                                class="text-center"
                                                            >
                                                                <a
                                                                    routerLink="/purchase-order-detail/{{
                                                                        po.po_no
                                                                    }}"
                                                                    >{{
                                                                        po.po_no
                                                                    }}</a
                                                                >
                                                            </td>

                                                            <td
                                                                class="text-center"
                                                                *ngIf="
                                                                    po.po_ses_mat ===
                                                                    'SERV'
                                                                "
                                                            >
                                                                Service
                                                            </td>
                                                            <td
                                                                class="text-center"
                                                                *ngIf="
                                                                    po.po_ses_mat ===
                                                                    'MAT'
                                                                "
                                                            >
                                                                Material
                                                            </td>
                                                            <td
                                                                class="text-center"
                                                            >
                                                                {{
                                                                    po.location
                                                                }}
                                                            </td>
                                                            <td>
                                                                <ng-container *ngIf="loadingDetailsSet.has(po.po_no)">
                                                                    <span class="spinner-border spinner-border-sm text-secondary" role="status" aria-label="Loading"></span>
                                                                </ng-container>
                                                                <ng-container *ngIf="!loadingDetailsSet.has(po.po_no)">
                                                                    {{ po.po_value | inrdisplay }}
                                                                </ng-container>
                                                            </td>

                                                            <td>
                                                                <ng-container *ngIf="loadingDetailsSet.has(po.po_no)">
                                                                    <span class="spinner-border spinner-border-sm text-secondary" role="status" aria-label="Loading"></span>
                                                                </ng-container>
                                                                <ng-container *ngIf="!loadingDetailsSet.has(po.po_no)">
                                                                    {{ po.openPoValue | inrdisplay }}
                                                                </ng-container>
                                                            </td>
                                                            <td>
                                                                <ng-container *ngIf="loadingDetailsSet.has(po.po_no)">
                                                                    <span class="spinner-border spinner-border-sm text-secondary" role="status" aria-label="Loading"></span>
                                                                </ng-container>
                                                                <ng-container *ngIf="!loadingDetailsSet.has(po.po_no)">
                                                                    {{ po.invoicedAmount | inrdisplay }}
                                                                </ng-container>
                                                            </td>
                                                            <td>
                                                                <ng-container *ngIf="loadingDetailsSet.has(po.po_no)">
                                                                    <span class="spinner-border spinner-border-sm text-secondary" role="status" aria-label="Loading"></span>
                                                                </ng-container>
                                                                <ng-container *ngIf="!loadingDetailsSet.has(po.po_no)">
                                                                    {{ po.inProcessInvoicedAmount | inrdisplay }}
                                                                </ng-container>
                                                            </td>
                                                            <td
                                                                class="text-center"
                                                            >
                                                                {{
                                                                    po.po_currency
                                                                }}
                                                            </td>
                                                            <td
                                                                class="text-center"
                                                            >
                                                                <a
                                                                    *ngIf="
                                                                        po.po_ses_mat ===
                                                                            'MAT' &&
                                                                        po.canSubmitInvoice ===
                                                                            true &&
                                                                        impersonate ===
                                                                            'false'
                                                                    "
                                                                    routerLink="/proof-of-delivery/{{
                                                                        po._id
                                                                    }}"
                                                                    class="btn-action-link"
                                                                >
                                                                    Submit
                                                                    Invoice
                                                                </a>
                                                                <a
                                                                    *ngIf="
                                                                        po.po_ses_mat ===
                                                                            'MAT' &&
                                                                        po.canSubmitInvoice ===
                                                                            true &&
                                                                        impersonate ===
                                                                            'true'
                                                                    "
                                                                    routerLink="/proof-of-delivery/{{
                                                                        po._id
                                                                    }}"
                                                                    class="btn-action-link extended"
                                                                >
                                                                    View GRN
                                                                </a>
                                                                <ng-container
                                                                    *ngIf="
                                                                        po.po_ses_mat ===
                                                                            'MAT' &&
                                                                        po.canSubmitInvoice ===
                                                                            false
                                                                    "
                                                                    class="btn-action-link btn-extended"
                                                                >
                                                                    <div
                                                                        class="grn tooltip-popup"
                                                                    >
                                                                        <i
                                                                            class="ri-information-fill"
                                                                        ></i>
                                                                        <span
                                                                            class="tooltiptext"
                                                                            >Invoicing
                                                                            Party
                                                                            is
                                                                            different.
                                                                            <a
                                                                                routerLink="/view-grn/{{
                                                                                    po._id
                                                                                }}"
                                                                            >
                                                                                View
                                                                                GRN</a
                                                                            ></span
                                                                        >
                                                                    </div>
                                                                </ng-container>
                                                                <ng-container
                                                                    *ngIf="
                                                                        po.po_ses_mat ===
                                                                            'SERV' &&
                                                                        po.canSubmitInvoice ===
                                                                            false
                                                                    "
                                                                    class="btn-action-link btn-extended"
                                                                >
                                                                    <div
                                                                        class="grn tooltip-popup"
                                                                    >
                                                                        <i
                                                                            class="ri-information-fill"
                                                                        ></i>
                                                                        <span
                                                                            class="tooltiptext"
                                                                            >Invoicing
                                                                            Party
                                                                            is
                                                                            different.
                                                                        </span>
                                                                    </div>
                                                                </ng-container>
                                                                <a
                                                                    *ngIf="
                                                                        po.po_ses_mat ===
                                                                            'SERV' &&
                                                                        po.canSubmitInvoice ===
                                                                            true &&
                                                                        impersonate ===
                                                                            'false'
                                                                    "
                                                                    routerLink="/po-line-items/{{
                                                                        po.po_no
                                                                    }}"
                                                                    class="btn-action-link"
                                                                >
                                                                    Submit
                                                                    Invoice
                                                                </a>
                                                                <a
                                                                    *ngIf="
                                                                        po.po_ses_mat ===
                                                                            'SERV' &&
                                                                        po.canSubmitInvoice ===
                                                                            true &&
                                                                        impersonate ===
                                                                            'true'
                                                                    "
                                                                    routerLink="/po-line-items/{{
                                                                        po.po_no
                                                                    }}"
                                                                    class="btn-action-link"
                                                                >
                                                                    View Line
                                                                    Items
                                                                </a>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </ng-container>
                                            <ng-template #noResults>
                                                <p class="text-center">
                                                    No Results Found for "{{
                                                        searchTerm
                                                    }}"
                                                </p>
                                            </ng-template>
                                        </ng-container>

                                        <div class="table-footer py-3">
                                            <div class="row">
                                                <div class="col-sm-5">
                                                    <label
                                                        class="d-inline-flex align-items-center mb-3"
                                                    >
                                                        Show
                                                        <select
                                                            id="demo-show-entries"
                                                            class="form-select form-select-sm mx-1"
                                                            [(ngModel)]="
                                                                pageSize
                                                            "
                                                            (ngModelChange)="
                                                                refreshPos()
                                                            "
                                                        >
                                                            <option
                                                                [ngValue]="10"
                                                            >
                                                                10
                                                            </option>
                                                            <option
                                                                [ngValue]="25"
                                                            >
                                                                25
                                                            </option>
                                                            <option
                                                                [ngValue]="50"
                                                            >
                                                                50
                                                            </option>
                                                            <option
                                                                [ngValue]="100"
                                                            >
                                                                100
                                                            </option>
                                                        </select>
                                                        entries
                                                    </label>
                                                </div>
                                                <div class="col-sm-7">
                                                    <div class="text-end">
                                                        <!-- Showing 1-5 of 15 entries -->
                                                        <ngb-pagination
                                                            class="justify-content: flex-end !important;"
                                                            [collectionSize]="
                                                                collectionSize
                                                            "
                                                            [(page)]="page"
                                                            [pageSize]="
                                                                pageSize
                                                            "
                                                            [maxSize]="4"
                                                            [rotate]="true"
                                                            [ellipses]="false"
                                                            [boundaryLinks]="
                                                                true
                                                            "
                                                            (pageChange)="
                                                                refreshPos()
                                                            "
                                                        >
                                                        </ngb-pagination>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
